import React, { useEffect, useState } from 'react';
import { connect } from "react-redux";
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import {
    makeStyles,
    withStyles,
    Typography,
    Slide as MUISlide,
    Grid,
    OutlinedInput,
    InputAdornment,
    Switch,
    ListItemSecondaryAction,
    Chip,
    Popover,
    Box,
    DialogTitle,
    DialogContentText,
    Card,
    CardContent,
    FormHelperText,
    Collapse,
    Menu,
    MenuList,
    ClickAwayListener,
    Grow,
    Popper,
} from "@material-ui/core";
import ProfileSideBar from '../../components/ProfileSideBar/ProfileSideBar';
import Logo1 from '../../../components/logo1.component';
import { VerifiedIconDweb } from '../../../components/icons';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
import { accountCss } from './ProfileCss';
import { getUserDetails, accountDetails } from '../../../store/actions/authActionCreators'
import * as logger from "../../../logger";
import { trackDwebEvent } from "../../analytics";
import S3Uploader from "../../components/s3Uploader/s3Uploader";
import Alert from '@material-ui/lab/Alert';
import UamPopUp from "../../components/Dialog/UamPopUp";


const Account = ({ user, dispatchFetchUserDetails, dispatchEditUser }) => {

    const [userInfo, setUserInfo] = useState({ companyName: "", name: "", contactNumber: "", gst: "", panNumber: "", addressLine1: "", addressLine2: "", city_name: "", state_name: "", pincode: "" });
    const [recall, setRecall] = useState(false);
    const [profileImgLink, setProfileImgLink] = useState("");
    const [checkFileType, setCheckFileType] = useState(false);
    const [sizeFlag, setSizeFlag] = useState(false);
    const [uamDialogOpen, setUamDialogOpen] = useState(false);

    const classes = accountCss();

    useEffect(() => {

        setTimeout(() => {
            let uamPopUp = localStorage.getItem("UamPopupShown")

            if (!uamPopUp) {
                setUamDialogOpen(true)
            }
        }, 200)

    }, [])

    useEffect(() => {
        dispatchFetchUserDetails(
            () => {
                logger.log("Header component Dweb", "Fetch user details successfull");
                trackDwebEvent("Dweb Profile Page", {});
            },
            () => {
                logger.log("Header component Dweb", "Fetch user details failed");
            }
        );
    }, []);

    useEffect(() => {
        setUserInfo(user.userInfoProfile);
        if (user && user.userInfoProfile && user.userInfoProfile.s3ProfileLink) {
            setProfileImgLink(user.userInfoProfile.s3ProfileLink);
        }
    }, [user.userInfoProfile]);

    const handleAddProfilePhoto = (file) => {

        setCheckFileType(false);
        setSizeFlag(false);

        const profilePhoto = {
            s3ProfileLink: file
        }

        dispatchEditUser(profilePhoto,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    setProfileImgLink(file);
                    logger.log("Account Component Dweb", "Edit user successfull");
                }
            },
            () => {
                logger.log("Account Component Dweb", "Edit user failed");
            }
        );
    }

    const handleInvalidUpload = (values) => {
        if (values.checkFileType) {
            setCheckFileType(true);
        }
        if (values.sizeFlag) {
            setSizeFlag(true);
        }
    }

    const handleUamClose = () => {
        setUamDialogOpen(false)
    }

    return (
        <>
            <Grid container direction="row" style={{ flexWrap: 'nowrap' }}>
                <Grid item style={{ height: '100%' }} >
                    <ProfileSideBar />
                </Grid>

                <Grid item style={{ marginTop: 30 }} >
                    <Card className={classes.cardV1}>
                        <CardContent className={classes.cardContentV1} >
                            <div className={classes.divFlex} >
                                <div className={classes.divV16}>
                                    {!profileImgLink &&
                                        <div className={classes.divV3}>
                                            <Logo1 />
                                        </div>
                                    }
                                    {profileImgLink &&
                                        <div className={classes.divImg}>
                                            <img src={profileImgLink} className={classes.imgV1} />
                                        </div>
                                    }
                                    <S3Uploader directoryName={"/dweb-images/Account"} toggle={true} handleFile={handleAddProfilePhoto} fromProfileAccounts={true} id="accountDetails" displayErrorBelow={handleInvalidUpload} displayErrorMessageBelow={true} />
                                </div>
                                <div>
                                    {checkFileType &&
                                        <Alert severity="error" className="mtV1">Please select only .jpg, .jpeg and .png files</Alert>
                                    }
                                    {sizeFlag &&
                                        <Alert severity="error" className="mtV1">File size must be below 5MB.</Alert>
                                    }
                                </div>
                                <div className={classes.divV4}>
                                    <div className={classes.divFlexV1}>
                                        <div className={classes.divV5}>
                                            {userInfo && userInfo.companyName ? userInfo.companyName : ""}
                                        </div>
                                        <div>
                                            <VerifiedIconDweb />
                                        </div>
                                    </div>

                                    <div className={classes.divV6} >
                                        <div className={classes.nameV1}>
                                            {userInfo && userInfo.name ? userInfo.name : ""}
                                        </div>

                                        {(userInfo && userInfo.contactNumber) &&
                                            <>
                                                <FiberManualRecordIcon className={classes.recordIcon} />
                                                <div className={classes.nameV1}>
                                                    {userInfo && userInfo.contactNumber ? userInfo.contactNumber : ""}
                                                </div>
                                            </>
                                        }
                                    </div>

                                    <div className={classes.divV7}>
                                        <div>
                                            <div className={classes.divV8}>
                                                GST Number
                                            </div>
                                            <div className={classes.divV9}>
                                                {userInfo && userInfo.gst ? userInfo.gst : "N/A"}
                                            </div>
                                        </div>
                                        <div className={classes.mtV1}>
                                            <div className={classes.divV8}>
                                                PAN
                                            </div>
                                            <div className={classes.divV9} >
                                                {userInfo && userInfo.panNumber ? userInfo.panNumber : "N/A"}
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>

                <Grid item style={{ marginTop: 30 }} >
                    <Card className={classes.cardV1}>
                        <CardContent className={classes.cardContentV1}>
                            <div className={classes.divAddress}>
                                Address Information
                            </div>
                            <div className={classes.divV10}>
                                <div className={classes.divV14}>
                                    Address
                                </div>
                                <div className={classes.divV12} >
                                    {userInfo && userInfo.addressLine1 ? userInfo.addressLine1 : "N/A"}
                                </div>

                                <div className={classes.mtV1}>
                                    <div className={classes.divV14}>
                                        Address Line 2
                                    </div>
                                    <div className={classes.divV12}>
                                        {userInfo && userInfo.addressLine2 ? userInfo.addressLine2 : "N/A"}
                                    </div>
                                </div>

                                <div className={classes.divV15}>
                                    <div className={classes.fBV1}>
                                        <div className={classes.divV14}>
                                            City
                                        </div>
                                        <div className={classes.divV12}>
                                            {userInfo && userInfo.city_name ? userInfo.city_name : "N/A"}
                                        </div>
                                    </div>
                                    <div className={classes.fBV2}>
                                        <div className={classes.divV14}>
                                            State
                                        </div>
                                        <div className={classes.divV12}>
                                            {userInfo && userInfo.state_name ? userInfo.state_name : "N/A"}
                                        </div>
                                    </div>
                                </div>

                                <div className={classes.mtV1} >
                                    <div className={classes.divV14}>
                                        Pincode
                                    </div>
                                    <div className={classes.divV13}>
                                        {userInfo && userInfo.pincode ? userInfo.pincode : "N/A"}
                                    </div>
                                </div>
                            </div>
                        </CardContent>
                    </Card>
                </Grid>

            </Grid>

            {uamDialogOpen && <UamPopUp open={uamDialogOpen} onClose={handleUamClose} />}
        </>
    );
}

const mapStateToProps = (state) => ({ user: state.user, vehicle: state.vehicle });
const mapDispatchToProps = (dispatch) => ({
    dispatchFetchUserDetails: (onSuccess, onFailure) => {
        dispatch(getUserDetails(onSuccess, onFailure))
    },
    dispatchEditUser: (data, onSuccess, onFailure) => { dispatch(accountDetails(data, onSuccess, onFailure, false)) },
});

const AccountWithRouter = withRouter(Account);
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AccountWithRouter);